import { AbilityBuilder, Ability } from '@casl/ability';

export type Subjects = string;
export type Actions = 'manage' | 'create' | 'read' | 'update' | 'delete';

export type AppAbility = Ability<[Actions, Subjects]> | undefined;
export type ACLObj = {
  action: Actions;
  subject: string;
};

/**
 * Please define your own Ability rules according to your app requirements.
 * We have just shown Admin and Client rules for demo purpose where
 * admin can manage everything and client can just visit ACL page
 */
const defineRulesFor = (role: string, subject: string) => {
  const { can, rules } = new AbilityBuilder<Ability<[Actions, Subjects]>>(Ability);

  if (role === 'admin') {
    can('manage', 'all');
  } else if (role === 'client') {
    can(['read'], 'acl-page');
  } else {
    can(['read', 'create', 'update', 'delete'], subject);
  }

  return rules;
};

export const buildAbilityFor = (role: string, subject: string): AppAbility => {
  return new Ability<[Actions, Subjects]>(defineRulesFor(role, subject), {
    // https://casl.js.org/v6/en/guide/subject-type-detection
    // @ts-ignore
    detectSubjectType: object => object!.type
  });
};

export const defaultACLObj: ACLObj = {
  action: 'manage',
  subject: 'all'
};

export default defineRulesFor;
